import { Link } from "react-router-dom";
import { BRANCHES, PROGRAM_OPTIONS, SCHOOL_HOURS } from "../data/siteContent";

const PinterestIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
    <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
);

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4 text-orange-500">
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4 text-orange-500">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);

const LocationIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4 text-orange-500">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
  </svg>
);

const LogoIcon = () => (
  <div className="rounded-2xl bg-white px-4 py-3 shadow-md shadow-slate-950/10">
    <p className="brand-bippo text-lg leading-none text-slate-900">
      Seekers Bay
    </p>
    <p className="brand-bippo mt-1 text-[0.62rem] leading-none tracking-[0.32em] text-orange-500">
      Preschool
    </p>
  </div>
);

// Developer Credit Logo Component
const DevCreditIcon = () => (
  <svg 
    className="h-4 w-4 transition-colors duration-200 group-hover:text-orange-400" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="1.8" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

export default function KiddinFooter() {
  const socialLinks = [
    { icon: <PinterestIcon />, label: "Pinterest" },
    { icon: <XIcon />, label: "X" },
    { icon: <FacebookIcon />, label: "Facebook" },
    { icon: <InstagramIcon />, label: "Instagram" },
  ];

  const quickLinks = [
    { label: "Home", to: "/" },
    { label: "About Us", to: "/about" },
    { label: "Gallery", to: "/gallery" },
    { label: "Contact Us", to: "/contact" },
  ];

  // Developer info - replace with your details
  const developerInfo = {
    name: "FreelancerX",
    url: "https://freelancerx.in",
    role: "Web Development"
  };

  return (
    <footer
      className="w-full"
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #1a2540 60%, #0f172a 100%)",
        backgroundImage: `
          linear-gradient(135deg, #0f172a 0%, #1a2540 60%, #0f172a 100%),
          radial-gradient(circle at 20% 80%, rgba(249,115,22,0.04) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(16,185,129,0.03) 0%, transparent 50%)
        `,
        fontFamily: "'Nunito', sans-serif",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');
        .footer-link {
          transition: color 0.2s ease, transform 0.2s ease;
          display: inline-block;
        }
        .footer-link:hover {
          color: #f97316;
          transform: translateX(4px);
        }
        .social-btn {
          transition: all 0.25s ease;
          border: 1.5px solid rgba(255,255,255,0.15);
        }
        .social-btn:hover {
          border-color: #f97316;
          color: #f97316;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(249,115,22,0.2);
        }
        .grid-bg {
          background-image:
            linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
          background-size: 60px 60px;
        }
        .dev-credit-link {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          backdrop-filter: blur(4px);
          padding: 6px 16px;
          border-radius: 40px;
          font-size: 0.75rem;
          font-weight: 500;
          color: #9ca3af;
          transition: all 0.25s ease;
          text-decoration: none;
        }
        .dev-credit-link:hover {
          background: rgba(249,115,22,0.12);
          color: #f97316;
          border-color: rgba(249,115,22,0.3);
          transform: translateY(-1px);
          box-shadow: 0 4px 10px rgba(0,0,0,0.2);
        }
      `}</style>

      {/* Top Glass Panel - Contact, Branches, Social */}
      <div className="grid-bg px-4 pb-4 pt-6 md:px-10">
        <div
          className="mx-auto flex max-w-6xl flex-col gap-4 rounded-2xl px-6 py-4"
          style={{ background: "rgba(255,255,255,0.06)", backdropFilter: "blur(8px)", border: "1px solid rgba(255,255,255,0.08)" }}
        >
          <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-6">
            <a href="tel:+917618759333" className="flex items-center gap-2 text-sm font-medium text-gray-300 transition-colors hover:text-orange-400">
              <PhoneIcon /> +91-7618759333
            </a>
            <a href="mailto:preethi@seekersbay.in" className="flex items-center gap-2 text-sm font-medium text-gray-300 transition-colors hover:text-orange-400">
              <MailIcon /> preethi@seekersbay.in
            </a>
          </div>
          <div className="grid gap-3 md:grid-cols-2">
            {BRANCHES.map((branch) => (
              <div key={branch.id} className="flex items-start gap-2 text-sm font-medium text-gray-300">
                <LocationIcon />
                <div>
                  <p className="font-semibold text-white">{branch.name}</p>
                  <p>{branch.address}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="flex items-center gap-2">
            {socialLinks.map((social) => (
              <button
                key={social.label}
                aria-label={social.label}
                className="social-btn flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-transparent text-gray-400"
              >
                {social.icon}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Footer Grid */}
      <div className="grid-bg px-4 py-10 md:px-10">
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="mb-4 flex items-center gap-3">
              <LogoIcon />
            </div>
            <p className="text-sm leading-relaxed text-gray-400">
              Seekers Bay Preschool has nurtured young learners since 2018 with a warm, play-based environment, strong parent communication, and two welcoming branches in Bangalore.
            </p>
          </div>

          <div>
            <h4 className="mb-5 text-base font-bold text-white">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link}>
                  <Link to={link.to} className="footer-link text-sm text-gray-400">{link.label}</Link>
                </li>
              ))}
            </ul>
            <Link to="/event-registration" className="mt-5 inline-block text-xs font-semibold uppercase tracking-[0.22em] text-orange-400 transition hover:text-orange-300">
              Event Registration
            </Link>
          </div>

          <div>
            <h4 className="mb-5 text-base font-bold text-white">Our Programs</h4>
            <ul className="space-y-3">
              {PROGRAM_OPTIONS.map((program) => (
                <li key={program}>
                  <span className="footer-link text-sm text-gray-400">{program}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-5 text-base font-bold text-white">School Hours</h4>
            <div className="space-y-3 text-sm">
              <div className="rounded-2xl bg-white/5 px-4 py-3">
                <p className="font-semibold text-orange-400">{SCHOOL_HOURS.statusLabel}</p>
                <p className="mt-1 text-gray-200">{SCHOOL_HOURS.openToday}</p>
              </div>
              <div className="flex justify-between gap-4">
                <span className="font-semibold text-orange-400">School Time:</span>
                <span className="text-right text-gray-300">08:30 am - 05:00 pm</span>
              </div>
              <div className="flex justify-between gap-4">
                <span className="font-semibold text-orange-400">Sunday:</span>
                <span className="text-right text-gray-300">Closed</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar - Copyright and Developer Credit - BOTH CENTERED */}
      <div className="relative flex flex-col items-center justify-center gap-3 px-4 py-5 md:px-10" style={{ borderTop: "1px solid rgba(255,255,255,0.07)" }}>
        {/* Decorative pencil element */}
        <div className="pointer-events-none absolute bottom-0 left-2 hidden select-none text-2xl opacity-30 sm:block">
          ✏️
        </div>
        
        {/* Copyright centered */}
        <p className="text-center text-sm text-gray-500">Copyright © 2026 All Rights Reserved.</p>
        
        {/* Developer Credit with Logo and Link - Centered below copyright */}
        <a 
          href={developerInfo.url}
          target="_blank"
          rel="noopener noreferrer"
          className="dev-credit-link group"
          aria-label={`Website developed by ${developerInfo.name}`}
        >
          {/* <DevCreditIcon /> */}
          <span className="text-xs tracking-wide">
            Developed by <span className="font-semibold text-orange-400/90 transition-colors group-hover:text-orange-400">{developerInfo.name}</span>
          </span>
        </a>
      </div>
    </footer>
  );
}
